import * as SerializerLib from "jsonapi-serializer";

import { serializeError } from "../base.serializer";

const JSONAPISerializer = SerializerLib.Serializer;

const opts = {
  attributes: [
    "pageType",
    "pageId",
    "itemType",
    "itemId",
    "sessionId",
    "userId",
    "userType",
    "userAgent",
    "visitedUrl"
  ]
};

export const serialize = (data) => {
  try {
    const Serializer = new JSONAPISerializer("reporting", opts);
    return Serializer.serialize(data);
  } catch (err) {
    return serializeError(err);
  }
};
